import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-chat-3-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 font-heading">
                一品楼论坛
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              汇聚优质内容的综合性交流社区，提供最新资讯、热门话题讨论与会员互动。加入我们，与数万名活跃用户共享精彩内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link></li>
              <li><Link to="/category/tech-discussion" className="text-sm text-background-400 hover:text-background-100 transition-colors">技术交流</Link></li>
              <li><Link to="/category/life-sharing" className="text-sm text-background-400 hover:text-background-100 transition-colors">生活分享</Link></li>
              <li><Link to="/category/digital-gadgets" className="text-sm text-background-400 hover:text-background-100 transition-colors">数码科技</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-400">contact@yipinlou.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-400">客服QQ群：88888888</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-background-400 text-sm mt-0.5"></i>
                <span className="text-sm text-background-400">北京市朝阳区科技园路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 一品楼论坛 版权所有 | 京ICP备2024000001号-1
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}